import { render } from "./BrandingIdentityComponent.vue?vue&type=template&id=b9764d48&scoped=true"
import script from "./BrandingIdentityComponent.vue?vue&type=script&lang=js"
export * from "./BrandingIdentityComponent.vue?vue&type=script&lang=js"

import "./BrandingIdentityComponent.vue?vue&type=style&index=0&id=b9764d48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9764d48"]])

export default __exports__